<template>
	<div class="tab-page">
		<form @submit.prevent="nextStep" ref="form">
			<div class="field">
				<div class="container">
					<div class="content">
						<div class="field-inner">
							<label for="yarn-type">
								<span class="info" :data-tooltip="$t('yarn-type-help')">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M8.1 4.5h1.8v1.8H8.1zm0 3.6h1.8v5.4H8.1zm.9 8.1A7.2 7.2 0 1 1 16.2 9 7.22 7.22 0 0 1 9 16.2zM9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9z"/></svg>
								</span>
								{{$t('yarn-type')}}
							</label>
							<div class="element">
								<div class="flex">
									<select id="yarn-type" v-model="data.yarnType">
										<option
											v-for="(type, index) in $yarnUtils.types"
											:key="'type-'+index"
											:value="type.code"
										>
											{{$t(type.name)}}
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="field" v-if="showNeedlesNumber">
				<div class="container">
					<div class="content">
						<div class="field-inner">
							<label for="needles-number">
								{{$t('needles-number')}}
							</label>
							<div class="element">
								<div class="flex">
									<input type="number" id="needles-number" v-model="data.needlesNumber" placeholder=" " min="0">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="field" v-if="showNeedlesNumber">
				<div class="container">
					<div class="content">
						<div class="field-inner">
							<label for="head-type">
								{{$t('head-type-?')}}
							</label>
							<div class="element">
								<div class="flex">
									<select id="head-type" v-model="data.workingPositions">
										<option :value="1">{{$t('1-working-position')}}</option>
										<option :value="2">{{$t('2-working-positions')}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Core key="default" v-if="!oneWorkingPosition" :min.sync="data.minCores" :max.sync="data.maxCores" :fields.sync="data.cores" name="default"/>
			<Core key="a" v-if="oneWorkingPosition" :min.sync="data.minCores" :max.sync="data.maxCores" :fields.sync="data.coresA" name="a"><template #title>{{$t('cores-a')}}</template></Core>
			<Core key="b" v-if="oneWorkingPosition" :min.sync="data.minCores" :max.sync="data.maxCores" :fields.sync="data.coresB" name="b"><template #title>{{$t('cores-b')}}</template></Core>
			<Covering :min.sync="data.minCoverings" :max.sync="data.maxCoverings" :fields.sync="data.coverings"/>
			<Effect :min.sync="data.minEffects" :max.sync="data.maxEffects" :type.sync="data.effectType" :fields.sync="data.effects"/>
		</form>
		<hr>
		<div class="container">
			<div class="content">
				<button class="" @click="nextStep">{{$t('apply')}}</button>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Core from '@/components/Core.vue'
import Covering from '@/components/Covering.vue'
import Effect from '@/components/Effect.vue'

export default {
	props: ['data'],
	computed: {
		showNeedlesNumber() {
			let rst = false;
			switch (this.data.yarnType) {
				case 'fancy-yarn':
					rst = false;
					break;
				case 'ribbon-yarn':
					rst = true;
					break;
				case 'soft-knit-yarn':
					rst = true;
					break;
			}
			return rst;
		},
		oneWorkingPosition() {
			let rst = false;
			if(this.data.workingPositions == 2) rst = true;
			return rst;
		}
	},
	methods: {
		nextStep() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			this.$parent.enableTab(2);
		},
	},
	components: {
		Core,
		Covering,
		Effect
	},
}
</script>